import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import BackgroundEffects from './BackgroundEffects';
import ShootingStar from './ShootingStar';
import SafeIcon from '../common/SafeIcon';

const STUDIO_PIN = '6993';

const PasswordGate = ({ onUnlock }) => {
  const [pin, setPin] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (pin === STUDIO_PIN) {
      onUnlock();
      return;
    }
    setPin('');
    setError(true);
  };

  return (
    <main className="min-h-screen grid place-items-center px-6">
      <BackgroundEffects />
      <ShootingStar />
      <motion.section
        initial={{ opacity: 0, y: 20, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        className="gate-panel relative w-full max-w-sm p-8 sm:p-10"
      >
        <div className="flex items-center justify-between mb-12">
          <img
            src="https://media-manager-c.questera.ai/greta-media/f3431c01043f6ae8468982ada2c320c1b5f2e30df31f9c1fc9d61ccd4574fa71cea2ac7949ae73f0d2854f304172067e/images/aW1hZ2UvcG5n/5dd897f97c55e1aa90164e2d5d40e6e9.png"
            alt="Vicinity"
            className="h-7 w-auto"
          />
          <span className="flex items-center gap-2 text-[9px] uppercase tracking-[0.2em] text-slate-600">
            <SafeIcon name="Shield" />
            Staff access
          </span>
        </div>

        <h1 className="text-2xl font-bold text-[#e8e6e2]">Welcome back.</h1>
        <p className="mt-2 mb-8 text-xs leading-6 text-slate-500">
          Enter the shared studio PIN to open the internal tools dashboard.
        </p>

        <form onSubmit={handleSubmit}>
          <label className="block mb-2 text-[10px] uppercase tracking-[0.18em] text-slate-600">
            Studio PIN
          </label>
          <motion.input
            animate={error ? { x: [-5, 5, -4, 4, 0] } : {}}
            type="password"
            inputMode="numeric"
            autoComplete="current-password"
            autoFocus
            maxLength={8}
            value={pin}
            onChange={(event) => {
              setPin(event.target.value);
              setError(false);
            }}
            placeholder="••••"
            className="gate-input w-full px-4 py-3 text-center text-xl tracking-[0.55em] outline-none"
          />
          <AnimatePresence>
            {error && (
              <motion.p
                initial={{ opacity: 0, y: -3 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
                className="mt-2 text-[10px] text-[#b58196]"
              >
                That PIN is incorrect. Please try again.
              </motion.p>
            )}
          </AnimatePresence>
          <button type="submit" className="gate-button w-full mt-5 py-3 text-xs font-semibold">
            Unlock dashboard
          </button>
        </form>

        <p className="mt-8 text-center text-[9px] uppercase tracking-[0.16em] text-slate-700">
          Vicinity · Internal use only
        </p>
      </motion.section>
    </main>
  );
};

export default PasswordGate;